import { ChangeDetectionStrategy, Component, inject, model, signal,} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { Partenaire } from '../../../shared/model';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators, ɵInternalFormsSharedModule } from '@angular/forms';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { CollaborateurService } from '../../service/collaborateur-service';
import { MatIcon } from '@angular/material/icon';


@Component({
  selector: 'app-police-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatSlideToggle,
    MatIcon
],
  templateUrl: './modal-police.html',
  styleUrl: './modal-police.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PoliceComponentModal {
  readonly dialogRef = inject(MatDialogRef<PoliceComponentModal>);
  readonly partenaire = inject<Partenaire>(MAT_DIALOG_DATA);
  partForm : FormGroup = new FormGroup({})

  data !: {police : string, code : string, categorie : string, join : boolean}

  policeValue : string = ""

  constructor(
    private fb : FormBuilder,
    private collaborateurService : CollaborateurService,
  ){}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.partForm = this.fb.group({
      code : [this.partenaire.code_partenaire??''],
      categorie : [this.partenaire.categorie??0],
      police : [this.partenaire.format_police??'{A:0}{B:false}{R:0}{C:0}{I:0}{N:false}', Validators.required],
      join : [this.partenaire.join??false]
    })
    this.generatePolice(this.partenaire.format_police??'{A:0}{B:false}{R:0}{C:0}{I:0}{N:false}')
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.partForm.valueChanges.subscribe((res : {police : string, code : string, categorie : string}) =>{
      this.generatePolice(res.police)
    })
  }

  generatePolice(format : string){
    this.policeValue = format.replace(/\{([^}]+)\}/g, (match, contenu) => {

        // 1. Convertir le contenu de l'accolade en un objet JavaScript propre
        const jsonString = `{${contenu}}`.replace(/([a-zA-Z0-9_]+):/g, '"$1":');
        const obj = (JSON?.parse(jsonString!))??null;

        // 2. Extraire la clé (ex: "A") et la valeur (ex: 4)
        const cle = Object.keys(obj)[0];
        const valeur = obj[cle];

        if(valeur == null || valeur == 0)return ''

        if (cle == 'A') {
          // A digit annee
          return this.getDigitYear(valeur).toString()
        }else if(cle == 'B'){
          // B digit bureau
          return valeur?'CB':''
        }else if(cle == 'I'){
          // I digit compteur
          return this.getDigitValue(0, valeur).toString()
        }else if(cle == 'C'){
          // C digit categorie
          return this.getDigitValue(this.partForm.get('categorie')?.value, valeur).toString()
        }else if(cle == 'R'){
          // R digit reference collab - compagnie
          return this.getDigitValue(this.partForm.get('code')?.value, valeur).toString()
        }else if(cle == 'N'){
          // N alias assure
          return valeur?'AS':''
        }else{

          return ''
        }
    });
  }

  getDigitValue(nb : number, digits : string){
    return nb.toString().padStart(parseInt(digits), '0')
  }

  getDigitYear(digits : number){
    if(digits==2)
      return new Date().getFullYear() % 100
    else
      return new Date().getFullYear();
  }

  onSend(){
    this.data = {
      police : this.partForm.get('police')?.value,
      code : this.partForm.get('code')?.value,
      categorie : this.partForm.get('categorie')?.value,
      join : this.partForm.get('join')?.value
    }

    this.dialogRef.close(this.data)
  }

  onClose(){
    this.dialogRef.close(null)
  }

    checkValue(key : string, value : string, fromName : string){
    if(value == '')
      return;

    this.collaborateurService.checkValues(key, value)
    .then((res) =>{
      if(res)
        this.partForm?.get(fromName)?.setErrors({'exist' : true})
      else
        this.partForm?.get(fromName)?.setErrors(null)
    })
  }
}
